import { createSlice } from "@reduxjs/toolkit";

export const selectionTyoeSlice = createSlice({
  name: "selection type",
  initialState: {
    selectionType: "add_service",
  },
  reducers: {
    setSelectionType: (state, action) => {
      state.selectionType = action.payload;
    },
  },
});

export const { setSelectionType } = selectionTyoeSlice.actions;

export default selectionTyoeSlice.reducer;
